import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d4356db"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-sidebar-options" }
const _hoisted_2 = { class: "wrapper-title" }
const _hoisted_3 = { class: "icons" }

import ProfileImage from "@/components/images/ProfileImage.vue";
import ChatSidebarSearchBar from "@/components/chat/chatSidebar/ChatSidebarSearchBar.vue";
import { GetterTypes, MutationTypes, store } from "@/store";
import { AppEnvironment, LayoutTypes } from "@/store/app/state";
import { useComputedValue } from "@/composables";
import { Profile } from "@/store/auth/state";
import { useRouter } from "vue-router";
import { computed } from "vue";
import Icon from "@/components/icons/Icon/Icon.vue";
import { IconType } from "@/types/icons";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatSidebarTopBar',
  setup(__props) {

const profile = useComputedValue<Profile>(GetterTypes.GET_AUTH_PROFILE);
const layoutType = useComputedValue<LayoutTypes>(GetterTypes.GET_LAYOUT_TYPE);
const router = useRouter();
const environment = useComputedValue<AppEnvironment>(
  GetterTypes.GET_APP_ENVIRONMENT,
);
const isMobileApp = computed(() => environment.value.isMobileApp);

const handleOpenNewChat = () => {
  store.commit(MutationTypes.REMOVE_SELECTED_CHAT);
  router.push("/new");
};

const appliedIcon = computed(() => {
  let iconName = "NEW_MESSAGE";
  if (layoutType.value === LayoutTypes.MOBILE) {
    iconName += "_ORANGE";
  }

  return IconType[iconName as keyof typeof IconType];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(layoutType) === _unref(LayoutTypes).MOBILE && isMobileApp.value)
        ? (_openBlock(), _createBlock(ProfileImage, {
            key: 0,
            id: _unref(profile).id,
            image: _unref(profile).picture,
            size: 36,
            "redirect-link": "/settings"
          }, null, 8, ["id", "image"]))
        : _createCommentVNode("", true),
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t("chat.chatSidebar.ChatSidebarTopBar.title")), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Icon, {
          icon: appliedIcon.value,
          class: "icon",
          onClick: handleOpenNewChat
        }, null, 8, ["icon"])
      ])
    ]),
    _createVNode(ChatSidebarSearchBar)
  ]))
}
}

})